import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGlass: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGlass"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 5.25C8.27208 5.25 5.25 8.27208 5.25 12C5.25 12.1889 5.25815 12.3762 5.27344 12.5615L6.76758 12.4385C6.75567 12.2941 6.75 12.1478 6.75 12C6.75 9.1005 9.1005 6.75 12 6.75C12.1478 6.75 12.2941 6.75567 12.4385 6.76758L12.5615 5.27344C12.3762 5.25815 12.1889 5.25 12 5.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGlass;
